import SubRegions from './SubRegions';

export default SubRegions;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/SubRegions/index.js